/* unplugin-vue-components disabled */import { render } from "./IndexAdmin.vue?vue&type=template&id=2d12a81f"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__